import React, { useState } from "react";
import { IoMdArrowRoundBack } from "react-icons/io";
import { FaEdit, FaTrash } from "react-icons/fa";
import Dialog from "./Dialog/Dialog";

const StudentPreview = ({ student, onEdit, onDelete, onBack }) => {
  const [dialog, setDialog] = useState({
    isOpen: false,
    type: "",
    title: "",
    message: "",
  });

  if (!student) return null;

  const getInitials = (firstName, lastName) => {
    return `${firstName?.[0] || ""}${lastName?.[0] || ""}`.toUpperCase();
  };

  const getGradient = (studentId) => {
    const gradients = [
      "linear-gradient(135deg, #ff9a9e 0%, #fad0c4 100%)",
      "linear-gradient(135deg, #a8edea 0%, #fed6e3 100%)",
      "linear-gradient(135deg, #fbc2eb 0%, #a6c1ee 100%)",
      "linear-gradient(135deg, #84fab0 0%, #8fd3f4 100%)",
    ];
    const index = parseInt(studentId?.slice(-2) || "0") % gradients.length;
    return gradients[index];
  };

  const handleDelete = () => {
    setDialog({
      isOpen: true,
      type: "confirm",
      title: "Confirm Deletion",
      message: `Are you sure you want to delete ${student.firstName} ${student.lastName}'s record?`,
      onConfirm: () => {
        onDelete(student.studentId);
        setDialog({ isOpen: false });
      },
      onCancel: () => setDialog({ isOpen: false }),
    });
  };

  // For demo purposes, we'll use a placeholder image or initials
  const showPhotoPlaceholder = true; // Set to false if you want to use actual photos

  const firstName = student.firstName || "N/A";
  const middleName = student.middleName || "";
  const lastName = student.lastName || "N/A";
  const fatherName = student.fathersName || "N/A";
  const motherName = student.mothersName || "N/A";
  const phoneNumber = student.phoneNumber || "N/A";
  const email = student.email || "N/A";
  const className = student.className || "N/A";
  const gender = student.gender || "N/A";
  const dateOfBirth = student.dateOfBirth || "N/A";

  return (
    <>
      <div className="student-preview box">
        <div className="preview-header">
          <div className="back-button" onClick={onBack}>
            <IoMdArrowRoundBack />
            <span>Back to List</span>
          </div>

          <h2 className="main-heading">Student Details Preview</h2>
          <div className="actions">
            <button className="action-btn edit" onClick={() => onEdit(student)}>
              <FaEdit /> Edit
            </button>
            <button className="action-btn delete" onClick={handleDelete}>
              <FaTrash /> Delete
            </button>
          </div>
        </div>
        <div className="preview-content">
          <div className="profile-item">
            <div className="profile">
              {!showPhotoPlaceholder && student.photo ? (
                <img
                  src={student.photo} // Now expects a local image path or URL
                  alt="Student Profile"
                  onError={(e) => {
                    e.target.style.display = "none";
                    e.target.nextSibling.style.display = "flex";
                  }}
                />
              ) : (
                <div
                  className="dummy-profile"
                  style={{ background: getGradient(student.studentId) }}
                >
                  {getInitials(firstName, lastName)}
                </div>
              )}
            </div>
            <div className="profile-details">
              <h3>{`${firstName} ${middleName} ${lastName}`.trim()}</h3>
              <p>Student ID: {student.studentId || "N/A"}</p>
            </div>
          </div>
          <div className="preview-item">
            <h5 className="sub-heading">Basic Details</h5>
            <p>
              <strong>Class:</strong> {className}
            </p>
            <p>
              <strong>Gender:</strong> {gender}
            </p>
            <p>
              <strong>Date of Birth:</strong> {dateOfBirth}
            </p>
          </div>
          <div className="preview-item">
            <h5 className="sub-heading">Parents Information</h5>
            <p>
              <strong>Father's Name:</strong> {fatherName}
            </p>
            <p>
              <strong>Mother's Name:</strong> {motherName}
            </p>
            <p>
              <strong>Phone Number:</strong> {phoneNumber}
            </p>
            <p>
              <strong>Email:</strong> {email}
            </p>
          </div>
        </div>
      </div>

      <Dialog
        isOpen={dialog.isOpen}
        type={dialog.type}
        title={dialog.title}
        message={dialog.message}
        onConfirm={dialog.onConfirm}
        onCancel={dialog.onCancel}
      />
    </>
  );
};

export default StudentPreview;
